import {library} from "@fortawesome/fontawesome-svg-core";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {
  faUser,
  faHome,
  faBars,
  faUsers,
  faUserPlus,
  faUnlock,
  faPlus,
  faPen,
  faShop,
  faMap,
  faCity,
  faStore,
  faWarehouse,
  faList,
  faBarcode,
  faMinus,
  faIndustry,
  faDollarSign,
  faRightFromBracket,
  faChartColumn,
  faBoxesStacked,
  faClipboardList,
  faRotateLeft,
  faRightLeft,
  faTable,
  faBoxArchive,
  faArrowLeft,
  faSliders,
  faSearch,
  faCircleCheck,
  faTrash,
  faCheck,
  faBoxOpen,
  faClockRotateLeft,
  faPrint,
  faChevronRight,
  faChevronLeft,
  faChevronDown,
  faXmarkCircle,
  faGear,
  faCopy,
  faCircleExclamation,
  faCircleChevronLeft, faLock, faUserTie, faXmark, faTriangleExclamation, faRetweet,
} from "@fortawesome/free-solid-svg-icons";
import {faCircleQuestion, faCreditCard} from "@fortawesome/free-regular-svg-icons";

library.add(
  faUser,
  faHome,
  faBars,
  faUsers,
  faUserPlus,
  faUnlock,
  faPlus,
  faMinus,
  faPen,
  faShop,
  faMap,
  faCity,
  faStore,
  faWarehouse,
  faList,
  faBarcode,
  faIndustry,
  faDollarSign,
  faRightFromBracket,
  faChartColumn,
  faBoxesStacked,
  faClipboardList,
  faRotateLeft,
  faRightLeft,
  faCreditCard,
  faTable,
  faCircleQuestion,
  faBoxArchive,
  faArrowLeft,
  faSliders,
  faSearch,
  faCircleCheck,
  faTrash,
  faCheck,
  faBoxOpen,
  faClockRotateLeft,
  faPrint,
  faChevronRight,
  faChevronLeft,
  faChevronDown,
  faCircleChevronLeft,
  faXmarkCircle,
  faXmark,
  faGear,
  faCopy,
  faCircleExclamation,
  faTriangleExclamation,
  faLock,
  faUserTie,
  faBars,
  faRetweet
);

export default FontAwesomeIcon;
